import React from 'react';
import _ from 'lodash';
import ChevronDown from 'assets/svg/ChevronDown';
import { formatWord } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_ATTRIBUTE_EXPAND_COLLAPSE } from 'utils/mixpanelEventNames';
import { MultiSelectionDropDown } from 'components/molecules/Filter/MultiSelectionDropDown';
import useFilterV2Selection from 'hooks/Filter/useFilterV2Selection';
import FilterV2Chip from './FilterV2Chip';
import { attributeCardTitle } from './filterV2Labels';

interface Props {
    globalFilterContainerId: string;
    allDimAndAttributeType: any;
    allCheckedAttribute: any;
    attributeTypeExpandClose: any;
    setAttributeTypeExpandClose: any;
    onShowMore: () => void;
    screenFilterConfig: any;
    uppercaseFilterLabels?: boolean;
}

const MAX_INLINE_CHIPS = 3;

function FilterV2AttributeList({
    globalFilterContainerId,
    allDimAndAttributeType,
    allCheckedAttribute,
    attributeTypeExpandClose,
    setAttributeTypeExpandClose,
    onShowMore,
    screenFilterConfig,
    uppercaseFilterLabels,
}: Props) {
    const disabledAttributeTypes: string[] = screenFilterConfig?.disabledAttributeTypes ?? [];
    const { removeAttributeValue } = useFilterV2Selection(setAttributeTypeExpandClose);

    function toggleAttributeType(attributeType: any) {
        setAttributeTypeExpandClose((oldValue: String) => (oldValue == attributeType.name ? '' : attributeType.name));
        //mixpanel event
        trackEventMixpanel(GLOBAL_FILTER_ATTRIBUTE_EXPAND_COLLAPSE, {
            isExpanded: attributeTypeExpandClose === attributeType?.name ? false : true,
            attributeType: attributeType?.name,
            dimension: attributeType?.dimensionReference || '',
        });
    }

    return (
        <div>
            {allDimAndAttributeType.dimentions?.length > 0 &&
                allDimAndAttributeType.dimentions?.map((dim: any, key: number) => (
                    <div
                        className={`py-2 ${
                            allDimAndAttributeType.dimentions.length != key + 1 && `border-b border-filterV2Border`
                        }`}
                        key={dim.dimensionName}
                    >
                        {dim?.attribute?.map((attributeType: any) => {
                            const isAttributeDisabled = disabledAttributeTypes?.includes(
                                _.snakeCase(attributeType?.name),
                            );
                            const isExpanded = attributeTypeExpandClose === attributeType.name;
                            const selectedNames = Object.keys(allCheckedAttribute?.[attributeType.name] || {});
                            const label = uppercaseFilterLabels
                                ? formatWord(attributeType.name).toUpperCase()
                                : formatWord(attributeType.name);
                            return (
                                <div
                                    className={`px-4 py-2 ${isAttributeDisabled ? 'pointer-events-none' : ''}`}
                                    key={attributeType.name}
                                >
                                    <div
                                        className="flex justify-between items-center cursor-pointer font-xs font-medium leading-[21px] text-filterV2TextPrimary"
                                        onClick={() => {
                                            //if this attribute type is disabled then dont expand/collapse
                                            if (isAttributeDisabled) return;
                                            toggleAttributeType(attributeType);
                                        }}
                                    >
                                        <span>{label}</span>
                                        <span className="flex shrink-0">
                                            <ChevronDown direction={isExpanded ? 'up' : 'down'} />
                                        </span>
                                    </div>
                                    {isExpanded && (
                                        <MultiSelectionDropDown
                                            variant="v2"
                                            title={attributeCardTitle(attributeType.name)}
                                            onClose={() => setAttributeTypeExpandClose('')}
                                            globalFilterContainerId={globalFilterContainerId}
                                            attributeType={attributeType}
                                            dimension={dim}
                                            attributeTypeExpandFlag={isExpanded}
                                        />
                                    )}
                                    {selectedNames.length > 0 && (
                                        <div className="mt-2 flex flex-wrap gap-2">
                                            {selectedNames.slice(0, MAX_INLINE_CHIPS).map((attributeName: string) => (
                                                <FilterV2Chip
                                                    key={attributeName}
                                                    label={attributeName}
                                                    onRemove={() =>
                                                        removeAttributeValue(attributeType.name, attributeName)
                                                    }
                                                />
                                            ))}
                                        </div>
                                    )}
                                    {selectedNames.length > MAX_INLINE_CHIPS && (
                                        <div
                                            role="button"
                                            className="mt-2 flex h-5 w-fit items-center px-1 font-xxs font-medium leading-[18px] text-filterV2Primary cursor-pointer"
                                            onClick={() => onShowMore()}
                                        >
                                            Show More
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ))}
        </div>
    );
}

export default FilterV2AttributeList;
